import * as React from 'react'
import {indexedMap} from '../../../Data/ArrayHelper'
import {OrderTab} from './OrderState'
import {OrderAction} from './OrderActions'
import Card from 'material-ui/Card/Card'
import {TableBody, TableHeader, TableHeaderColumn, Table, TableRow} from 'material-ui/Table'
import TableRowColumn from 'material-ui/Table/TableRowColumn'
import {InquiryPosition} from '../../../Entities/InquiryPosition'
import {EditableFloatingActionButtons} from '../../../View/EditableFloatingActionButtons'
import TextField from 'material-ui/TextField'
import {Totals} from '../../../Entities/Totals'

export function OrderView({state, dispatch, active, totals}: {
    active: boolean
    state: OrderTab,
    dispatch: (action: OrderAction) => void,
    totals: Totals
}) {
    const disabled = state.editable.type === 'Locked'
    return (
        <div>
            {active &&
            <EditableFloatingActionButtons
                editable={state.editable}
                onEdit={() => dispatch({
                    type: 'EditOrderTab',
                })}
                onSave={() => dispatch({
                    type: 'SaveOrderTab',
                })}
                onDiscard={() => dispatch({
                    type: 'DiscardOrderTab',
                })}
            />
            }
            <div className="row">
                <div className="column">
                    <Card className="tab__form-card">
                        <div className="tab__form-header">
                            <h4>Rechnungsaddresse</h4>
                        </div>
                        <TextField
                            floatingLabelText="Name 1"
                            disabled={disabled}
                            value={state.invoiceAddressInput.invoiceName1}
                            onChange={(event, value) => dispatch({
                                type: 'InvoiceAddressChanged',
                                field: 'invoiceName1',
                                value: value
                            })}
                            underlineDisabledStyle={{display: 'none'}}
                            inputStyle={{color: 'black'}}
                            floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                            floatingLabelShrinkStyle={{color: 'black'}}
                            fullWidth={true}
                        />
                        <TextField
                            floatingLabelText="Name 2"
                            disabled={disabled}
                            value={state.invoiceAddressInput.invoiceName2}
                            onChange={(event, value) => dispatch({
                                type: 'InvoiceAddressChanged',
                                field: 'invoiceName2',
                                value: value
                            })}
                            underlineDisabledStyle={{display: 'none'}}
                            inputStyle={{color: 'black'}}
                            floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                            floatingLabelShrinkStyle={{color: 'black'}}
                            fullWidth={true}
                        />
                        <div style={{display: 'flex'}}>
                            <TextField
                                floatingLabelText="Straße"
                                disabled={disabled}
                                value={state.invoiceAddressInput.invoiceStreet}
                                onChange={(event, value) => dispatch({
                                    type: 'InvoiceAddressChanged',
                                    field: 'invoiceStreet',
                                    value: value
                                })}
                                underlineDisabledStyle={{display: 'none'}}
                                inputStyle={{color: 'black'}}
                                floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                                floatingLabelShrinkStyle={{color: 'black'}}
                                style={{flex: '1'}}
                            />
                            <div style={{flex: 'none', width: '8px'}}/>
                            <TextField
                                floatingLabelText="Hausnummer"
                                disabled={disabled}
                                value={state.invoiceAddressInput.invoiceHouseNumber}
                                onChange={(event, value) => dispatch({
                                    type: 'InvoiceAddressChanged',
                                    field: 'invoiceHouseNumber',
                                    value: value
                                })}
                                underlineDisabledStyle={{display: 'none'}}
                                inputStyle={{color: 'black'}}
                                floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                                floatingLabelShrinkStyle={{color: 'black'}}
                                style={{flex: 'none', width: '96px'}}
                            />
                        </div>
                        <div style={{display: 'flex'}}>
                            <TextField
                                floatingLabelText="Postleitzahl"
                                disabled={disabled}
                                value={state.invoiceAddressInput.invoiceZipCode}
                                onChange={(event, value) => dispatch({
                                    type: 'InvoiceAddressChanged',
                                    field: 'invoiceZipCode',
                                    value: value
                                })}
                                underlineDisabledStyle={{display: 'none'}}
                                inputStyle={{color: 'black'}}
                                floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                                floatingLabelShrinkStyle={{color: 'black'}}
                                style={{flex: 'none', width: '96px'}}
                            />
                            <div style={{flex: 'none', width: '8px'}}/>
                            <TextField
                                floatingLabelText="Stadt"
                                disabled={disabled}
                                value={state.invoiceAddressInput.invoiceCity}
                                onChange={(event, value) => dispatch({
                                    type: 'InvoiceAddressChanged',
                                    field: 'invoiceCity',
                                    value: value
                                })}
                                underlineDisabledStyle={{display: 'none'}}
                                inputStyle={{color: 'black'}}
                                floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                                floatingLabelShrinkStyle={{color: 'black'}}
                                style={{flex: '1'}}
                            />
                        </div>
                        <TextField
                            floatingLabelText="Land"
                            disabled={disabled}
                            value={state.invoiceAddressInput.invoiceCountry}
                            onChange={(event, value) => dispatch({
                                type: 'InvoiceAddressChanged',
                                field: 'invoiceCountry',
                                value: value
                            })}
                            underlineDisabledStyle={{display: 'none'}}
                            inputStyle={{color: 'black'}}
                            floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                            floatingLabelShrinkStyle={{color: 'black'}}
                            fullWidth={true}
                        />
                    </Card>
                </div>
                <div className="column">
                    <Card className="tab__form-card">
                        <div className="tab__form-header">
                            <h4>Lieferaddresse</h4>
                        </div>
                        <TextField
                            floatingLabelText="Name 1"
                            disabled={disabled}
                            value={state.deliveryAddressInput.deliveryName1}
                            onChange={(event, value) => dispatch({
                                type: 'DeliveryAddressChanged',
                                field: 'deliveryName1',
                                value: value
                            })}
                            underlineDisabledStyle={{display: 'none'}}
                            inputStyle={{color: 'black'}}
                            floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                            floatingLabelShrinkStyle={{color: 'black'}}
                            fullWidth={true}
                        />
                        <TextField
                            floatingLabelText="Name 2"
                            disabled={disabled}
                            value={state.deliveryAddressInput.deliveryName2}
                            onChange={(event, value) => dispatch({
                                type: 'DeliveryAddressChanged',
                                field: 'deliveryName2',
                                value: value
                            })}
                            underlineDisabledStyle={{display: 'none'}}
                            inputStyle={{color: 'black'}}
                            floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                            floatingLabelShrinkStyle={{color: 'black'}}
                            fullWidth={true}
                        />
                        <div style={{display: 'flex'}}>
                            <TextField
                                floatingLabelText="Straße"
                                disabled={disabled}
                                value={state.deliveryAddressInput.deliveryStreet}
                                onChange={(event, value) => dispatch({
                                    type: 'DeliveryAddressChanged',
                                    field: 'deliveryStreet',
                                    value: value
                                })}
                                underlineDisabledStyle={{display: 'none'}}
                                inputStyle={{color: 'black'}}
                                floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                                floatingLabelShrinkStyle={{color: 'black'}}
                                style={{flex: '1'}}
                            />
                            <div style={{flex: 'none', width: '8px'}}/>
                            <TextField
                                floatingLabelText="Hausnummer"
                                disabled={disabled}
                                value={state.deliveryAddressInput.deliveryHouseNumber}
                                onChange={(event, value) => dispatch({
                                    type: 'DeliveryAddressChanged',
                                    field: 'deliveryHouseNumber',
                                    value: value
                                })}
                                underlineDisabledStyle={{display: 'none'}}
                                inputStyle={{color: 'black'}}
                                floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                                floatingLabelShrinkStyle={{color: 'black'}}
                                style={{flex: 'none', width: '96px'}}
                            />
                        </div>
                        <div style={{display: 'flex'}}>
                            <TextField
                                floatingLabelText="Postleitzahl"
                                disabled={disabled}
                                value={state.deliveryAddressInput.deliveryZipCode}
                                onChange={(event, value) => dispatch({
                                    type: 'DeliveryAddressChanged',
                                    field: 'deliveryZipCode',
                                    value: value
                                })}
                                underlineDisabledStyle={{display: 'none'}}
                                inputStyle={{color: 'black'}}
                                floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                                floatingLabelShrinkStyle={{color: 'black'}}
                                style={{flex: 'none', width: '96px'}}
                            />
                            <div style={{flex: 'none', width: '8px'}}/>
                            <TextField
                                floatingLabelText="Stadt"
                                disabled={disabled}
                                value={state.deliveryAddressInput.deliveryCity}
                                onChange={(event, value) => dispatch({
                                    type: 'DeliveryAddressChanged',
                                    field: 'deliveryCity',
                                    value: value
                                })}
                                underlineDisabledStyle={{display: 'none'}}
                                inputStyle={{color: 'black'}}
                                floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                                floatingLabelShrinkStyle={{color: 'black'}}
                                style={{flex: '1'}}
                            />
                        </div>
                        <TextField
                            floatingLabelText="Land"
                            disabled={disabled}
                            value={state.deliveryAddressInput.deliveryCountry}
                            onChange={(event, value) => dispatch({
                                type: 'DeliveryAddressChanged',
                                field: 'deliveryCountry',
                                value: value
                            })}
                            underlineDisabledStyle={{display: 'none'}}
                            inputStyle={{color: 'black'}}
                            floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                            floatingLabelShrinkStyle={{color: 'black'}}
                            fullWidth={true}
                        />
                    </Card>
                </div>
                <div className="column">
                    <Card className="tab__form-card">
                        <div className="tab__form-header">
                            <h4>Weitere Informationen</h4>
                        </div>
                    </Card>
                </div>
            </div>
            <div className="row">
                <div className="column">
                    <Card>
                        <OrderTable positions={state.positions}/>
                    </Card>
                </div>
            </div>
        </div>
    )
}

function OrderTable({positions}: { positions: InquiryPosition[] }): JSX.Element {
    return (
        <Table
            selectable={false}
            fixedHeader={false}
            style={{marginTop: '16px'}}
        >
            <TableHeader
                displaySelectAll={false}
                adjustForCheckbox={false}
            >
                <TableRow>
                    <TableHeaderColumn style={{width: '15%'}}>
                        Name
                    </TableHeaderColumn>
                    <TableHeaderColumn style={{width: '35%'}}>
                        Beschreibung
                    </TableHeaderColumn>
                    <TableHeaderColumn>
                        Anzahl
                    </TableHeaderColumn>
                    <TableHeaderColumn>
                        Gewicht (g)
                    </TableHeaderColumn>
                    <TableHeaderColumn style={{textAlign: 'right'}}>
                        Preis (netto)
                    </TableHeaderColumn>
                    <TableHeaderColumn>
                        Druckdaten
                    </TableHeaderColumn>
                </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
                {indexedMap(
                    (index: number, inquiryPosition: InquiryPosition) =>
                        <OrderTablePosition
                            key={index}
                            position={inquiryPosition}
                        />,
                        positions,
                )}
            </TableBody>
        </Table>
    )
}

function OrderTablePosition({position}: { position: InquiryPosition }): JSX.Element {
    return (
        <TableRow>
            <TableRowColumn style={{width: '15%'}}>
                {position.name}
            </TableRowColumn>
            <TableRowColumn style={{width: '35%'}}>
                {position.notes}
            </TableRowColumn>
            <TableRowColumn>
                {position.amount}
            </TableRowColumn>
            <TableRowColumn>
                {position.weight}
            </TableRowColumn>
            <TableRowColumn style={{textAlign: 'right'}}>
                {position.totalNetPrice} €
            </TableRowColumn>
            <TableRowColumn>
                <span style={{fontStyle: 'italic'}}>fehlend</span>
            </TableRowColumn>
        </TableRow>
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/InquiryDetails/Order/OrderView.tsx